import React from 'react';
import { Link } from 'react-router-dom';

// import SignOutButton from '../SignOut';
import * as ROUTES from '../../constants/routes';
import { canViewFreightForwarder, isAdmin } from '../../utils/utilities';

import { AuthUserContext, ThemeContext } from '../Session';
// import { freightLegendTheme } from '../Session/themeContext';
import logo from '../../images/FreightLegendWhite.png'; // relative path to image

import AppBar from '@material-ui/core/AppBar';

// import MaterialIcon, {colorPalette} from 'material-icons-react';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
// import Typography from '@material-ui/core/Typography';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
// import IconButton from '@material-ui/core/IconButton';
// import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
// import Avatar from '@material-ui/core/Avatar';

import { withStyles } from '@material-ui/core/styles';
import { withAuthorization } from '../Session';
import { withRouter } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as Vectors } from '../../images/Vectors.svg';
import Utilities, { canDoSuperUserTasks, canEditFreightForwarder } from '../../utils/utilities';

import { compose } from 'recompose';

const styles = (theme) => {
  return {
    backgroundDivStyle: {
      backgroundColor: theme.palette.primary.main,
      height: '350px',
      right: '0px',
      left: '0px',
      position: 'absolute',
      zIndex: '-1',
    },
    vectors: {
      position: 'absolute',
      left: '0px',
      right: '0px',
      bottom: '0px',
    },
    leftIcon: {
      marginRight: theme.spacing(1),
    },
    outlineButton: {
      borderRadius: '100px',
      marginTop: theme.spacing(1),
    },
    textRed: {
      color: theme.palette.error.main,
    },
    dropDownButton: {
      color: theme.palette.common.white,
    },
    avatar: {
      maxWidth: 180,
      maxHeight: 50,
      backgroundColor: theme.palette.common.white,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(1),
      color: theme.palette.primary.main, // for img alt only to show
    },
    selectedTab: {
      backgroundColor: theme.palette.primary.dark,
    },
    tabRoot: {
      height: '80px',
    },
    logo: {
      maxWidth: '220px',
    },
  };
};

const GoBackButtonComp = (props) => {
  const { classes, className } = props;

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <Button
      onClick={goBack}
      size="large"
      variant="outlined"
      color="secondary"
      className={`${className} ${classes.outlineButton}`}
    >
      <FontAwesomeIcon className={classes.leftIcon} icon={faAngleLeft} />
      Go Back
    </Button>
  );
};

const Navigation = (props) => {
  return (
    <div>
      <AuthUserContext.Consumer>
        {({ authUser }) => (authUser ? <NavigationAuth {...props} authUser={authUser} /> : <NavigationNonAuth />)}
      </AuthUserContext.Consumer>
    </div>
  );
};

class NavigationAuth extends React.Component {
  constructor(props) {
    super(props);
    let { authUser } = props;
    this.navTabs = [
      {
        name: 'PORT PAIRS & BUY RATES',
        route: ROUTES.PORT_PAIRS_INDEX,
      },
      {
        name: 'MAINTENANCE',
        route: ROUTES.CHARGES,
      },
      {
        name: 'QUOTES',
        route: ROUTES.QUOTES,
      },
      {
        name: 'RATE SHEETS',
        route: ROUTES.RATE_SHEETS,
      },
    ];
    if (isAdmin(authUser)) {
      this.navTabs.push({
        name: 'ADMIN',
        route: ROUTES.USERS,
        useDefaultTheme: true,
      });
    }
    this.state = {
      anchorEl: null,
      anchorElFf: null,
      freightForwarders: [],
      authUser,
    };
  }

  componentDidMount() {
    this.getFreightForwarders();
    this.unlisten = this.props.history.listen((location, action) => {
      this.setActiveTab();
    });
    const isSuper = canDoSuperUserTasks(this.props.authUser);
    const canEdit = canEditFreightForwarder(this.props.authUser);
    this.setState({ isSuper, canEdit });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setActiveTab();
    }
  }

  componentWillUnmount() {
    this.unlisten();
  }

  setActiveTab = () => {
    let ffPathId;
    let curPathParts = this.props.location.pathname.split('/');
    curPathParts.forEach((part, index) => {
      if (part === 'freight-forwarders' && index + 1 < curPathParts.length) {
        ffPathId = curPathParts[index + 1];
      }
    });
    let activeTab = false;
    this.navTabs.forEach((navTab) => {
      let route = this.props.location.pathname.replace(ffPathId, ':freight_forwarder_id');
      if (navTab.route === route) {
        activeTab = navTab;
        if (activeTab.useDefaultTheme) {
          this.context.useDefaultTheme();
        }
      }
    });
    this.setState({ activeTab });
    return ffPathId; //for further use
  };

  getFreightForwarders = () => {
    let { authUser } = this.state;
    let ffPathId = this.setActiveTab();

    if (isAdmin(authUser)) {
      this.props.firebase.getAllRecursive('freightForwarders').then((freightForwarders) => {
        let currentFreightForwarder;
        if (ffPathId) {
          currentFreightForwarder = freightForwarders.find((f) => f._id === ffPathId);
        } else {
          currentFreightForwarder = freightForwarders.find((f) => f._id === authUser.default_freight_forwarder_id);
          // currentFreightForwarder = (freightForwarders && freightForwarders.length > 0) ? freightForwarders[0]: undefined
        }
        this.setState({
          freightForwarders,
          currentFreightForwarder,
        });
      });
    } else if (authUser.freight_forwarder_id) {
      this.props.firebase
        .freightForwarder(authUser.freight_forwarder_id)
        .then((currentFreightForwarder) => this.setState({ currentFreightForwarder }));
    }
  };

  handleChange = (event, activeTab) => {
    // do not set the active tab here because the FormNavConfirm may block the navigation
    // Instead, listin to the history changes and set teh active tab then
    // this.setState({ activeTab });
    if (activeTab.route) {
      let path = this.state.currentFreightForwarder
        ? activeTab.route.replace(':freight_forwarder_id', this.state.currentFreightForwarder._id)
        : activeTab.route;
      this.props.history.push(path);
    }
  };

  openMenu = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  openFreightForwarderMenu = (event) => {
    this.setState({
      anchorElFf: event.currentTarget,
    });
  };

  selectFreightForwarder = (currentFreightForwarder) => (event) => {
    let curId = this.state.currentFreightForwarder && this.state.currentFreightForwarder._id;
    let newId = currentFreightForwarder._id;
    this.setState(
      {
        currentFreightForwarder,
        anchorElFf: null,
      },
      () => {
        let curPath = this.props.location.pathname;
        if (curId !== newId && curPath.includes(curId)) {
          // let path = curPath.replace(curId, newId);
          let path = `/freight-forwarders/${newId}/quotes`;
          this.props.history.push(path);
        }
      }
    );
  };

  closeMenu = () => {
    this.setState({ anchorEl: null, anchorElFf: null });
  };

  render() {
    const { activeTab, anchorEl, anchorElFf, freightForwarders, currentFreightForwarder, isSuper, canEdit } =
      this.state;
    const { classes, firebase, authUser } = this.props;

    return (
      <div>
        <AppBar position="static">
          <Toolbar>
            <Grid justifyContent="space-between" alignItems="center" container spacing={3}>
              <Grid item>
                <img src={logo} alt="Freight Legend" className={classes.logo} />
              </Grid>
              <Grid item>
                {activeTab !== undefined && (
                  <Tabs value={activeTab} onChange={this.handleChange} centered>
                    {this.navTabs.map((navTab) => {
                      return (
                        <Tab
                          key={navTab.name}
                          value={navTab}
                          label={navTab.name}
                          classes={{ selected: classes.selectedTab, root: classes.tabRoot }}
                        />
                      );
                    })}
                  </Tabs>
                )}
              </Grid>
              <Grid item>
                <Grid container alignItems="center">
                  <Button
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={this.openMenu}
                    className={classes.dropDownButton}
                  >
                    <Box>
                      <Box>{authUser.name}</Box>
                      <Box>
                        <FontAwesomeIcon icon={faChevronDown} />
                      </Box>
                    </Box>
                  </Button>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={this.closeMenu}
                  >
                    {currentFreightForwarder && (
                      <MenuItem
                        onClick={this.closeMenu}
                        component={Link}
                        to={`/freight-forwarders/${currentFreightForwarder._id}/clients`}
                      >
                        Clients
                      </MenuItem>
                    )}
                    {currentFreightForwarder && (
                      <MenuItem
                        onClick={this.closeMenu}
                        component={Link}
                        to={`/freight-forwarders/${currentFreightForwarder._id}/agents`}
                      >
                        Agents
                      </MenuItem>
                    )}
                    {currentFreightForwarder && (
                      <Tooltip
                        placement="left-start"
                        title={canEdit ? '' : 'Please contact Super User to edit currencies'}
                      >
                        <span>
                          <MenuItem
                            disabled={!canEdit}
                            onClick={this.closeMenu}
                            component={Link}
                            to={`/freight-forwarders/${currentFreightForwarder._id}/currencies`}
                          >
                            Currencies
                          </MenuItem>
                        </span>
                      </Tooltip>
                    )}
                    {currentFreightForwarder && (
                      <Tooltip placement="left-start" title={isSuper ? '' : 'Please contact Super User to edit users'}>
                        <span>
                          <MenuItem
                            disabled={!isSuper}
                            onClick={this.closeMenu}
                            component={Link}
                            to={`/freight-forwarders/${currentFreightForwarder._id}/users`}
                          >
                            Staff
                          </MenuItem>
                        </span>
                      </Tooltip>
                    )}
                    {currentFreightForwarder && (
                      <MenuItem
                        onClick={this.closeMenu}
                        component={Link}
                        to={`/freight-forwarders/${currentFreightForwarder._id}/service-providers`}
                      >
                        Service Providers
                      </MenuItem>
                    )}
                    <Divider />
                    <MenuItem onClick={firebase.doSignOut} className={classes.textRed}>
                      Logout
                    </MenuItem>
                  </Menu>
                  {freightForwarders.length > 0 ? (
                    <React.Fragment>
                      <Button aria-controls="ff-menu" aria-haspopup="true" onClick={this.openFreightForwarderMenu}>
                        {currentFreightForwarder && currentFreightForwarder.logo_images && (
                          <img
                            alt={currentFreightForwarder.name}
                            src={Utilities.getPhotoUrl(currentFreightForwarder.logo_images, 'logo')}
                            className={classes.avatar}
                          />
                        )}
                      </Button>
                      <Menu
                        id="ff-menu"
                        anchorEl={anchorElFf}
                        keepMounted
                        open={Boolean(anchorElFf)}
                        onClose={this.closeMenu}
                      >
                        {freightForwarders.map((f) => (
                          <MenuItem key={f._id} onClick={this.selectFreightForwarder(f)}>
                            {f.name}
                          </MenuItem>
                        ))}
                      </Menu>
                    </React.Fragment>
                  ) : (
                    currentFreightForwarder &&
                    currentFreightForwarder.logo_images && (
                      <img
                        alt={currentFreightForwarder.name}
                        src={Utilities.getPhotoUrl(currentFreightForwarder.logo_images, 'logo')}
                        className={classes.avatar}
                      />
                    )
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
        <div className={classes.backgroundDivStyle}>
          <Vectors className={classes.vectors} />
        </div>
      </div>
    );
  }
}

NavigationAuth.contextType = ThemeContext;

const NavigationNonAuth = () => (
  <ul>
    <li>
      <Link to={ROUTES.LANDING}>Landing</Link>
    </li>
    <li>
      <Link to={ROUTES.SIGN_IN}>Sign In</Link>
    </li>
  </ul>
);

const condition = (authUser) => canViewFreightForwarder(authUser);

export default compose(withAuthorization(condition), withStyles(styles))(Navigation);

export const GoBackButton = compose(withRouter, withStyles(styles))(GoBackButtonComp);
